"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 02 2018
 */

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Optimization goal defines optimization strategy.
 *
 * @author RV
 */


exports.OPTIMIZATION_GOAL_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.OptimizationGoalType;
/**
 * Optimization goal enum used in the app, unfortunately it has different values than YDG.
 * So if used in the API you must transform it with `OptimizationGoalsSettings.goalToYDG()`.
 */

var OptimizationGoal;

(function (OptimizationGoal) {
  OptimizationGoal["Profit"] = "PROFIT";
  OptimizationGoal["Revenue"] = "REVENUE";
  OptimizationGoal["Balanced"] = "BALANCED";
})(OptimizationGoal = exports.OptimizationGoal || (exports.OptimizationGoal = {}));
/**
 * OptimizationGoalsSettings represents configuration for optimization.
 *
 * @author RV
 * @author Jan Prokop
 */


var OptimizationGoalsSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OptimizationGoalsSettings, _DomainObject_1$Domai);

  /**
   * Constructs optimization goals settings instance.
   *
   * @param optimalizationGoal
   */
  function OptimizationGoalsSettings(optimalizationGoal) {
    var _this;

    _classCallCheck(this, OptimizationGoalsSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGoalsSettings).call(this));
    _this.optimalizationGoal = optimalizationGoal;
    return _this;
  }
  /**
   * Compares two OptimizationGoalsSettings object and return null if they were same or the original if they were different
   *
   * @param resolvedOptimizationGoalsSettings
   * @returns null if they were same, otherwise returns original object
   */


  _createClass(OptimizationGoalsSettings, [{
    key: "diffOptimizationGoalsSettingsWithResolvent",
    value: function diffOptimizationGoalsSettingsWithResolvent(resolvedOptimizationGoalsSettings) {
      if (!this.optimalizationGoal) {
        return null;
      }

      if (resolvedOptimizationGoalsSettings && this.optimalizationGoal === resolvedOptimizationGoalsSettings.optimalizationGoal) {
        return null;
      }

      return this;
    }
    /**
     * Transforms OptimizationGoal enum item to optimizationGoal parameter accepted by YDG API.
     *
     * @param goal
     */

  }], [{
    key: "goalToYDG",
    value: function goalToYDG(goal) {
      switch (goal) {
        case OptimizationGoal.Profit:
          return 'Profit';

        case OptimizationGoal.Revenue:
          return 'Revenue';

        case OptimizationGoal.Balanced:
          return 'Balanced';
      }
    }
    /**
     * Transforms optimizationGoal parameter retrieved from YDG API to OptimizationGoal enum item.
     *
     * @param goal
     */

  }, {
    key: "YDGToGoal",
    value: function YDGToGoal(goal) {
      switch (goal) {
        case 'Profit':
          return OptimizationGoal.Profit;

        case 'Revenue':
          return OptimizationGoal.Revenue;

        case 'Balanced':
          return OptimizationGoal.Balanced;
      }

      if (!goal) {
        throw new TypeError("Optimization goal is missing.");
      } else {
        throw new TypeError("Optimization goal '".concat(goal, "' is not supported."));
      }
    }
  }]);

  return OptimizationGoalsSettings;
}(DomainObject_1.DomainObject);

exports.OptimizationGoalsSettings = OptimizationGoalsSettings;

OptimizationGoalsSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder();
  return {
    optimalizationGoal: builder.opt(builder.senum('optimalizationGoal', OptimizationGoal, 'enums/OptimizationGoal'))
  };
}();